/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const CanvasAreaVisibility = core.serialization.enum_(["visible", "hidden", "optional", "skeleton"]);
